import type { PostingsDataQuery } from '@revelio/data-access';

/**
 * Build a BreakdownSingleDataSet from the main Postings query result.
 * Works for secondary dimensions geography or company where the backend
 * returns entity.category[].metrics.count / share.
 */

import type { PostingMetricValues } from '../../PageConfigProvider/types/metric';
import {
  type BreakdownSingleDataSet,
  DataType,
  type SingleDataPoint,
} from '../types';

export const convertPostingBreakdown = ({
  data,
  metric,
}: {
  data: PostingsDataQuery['posting'];
  metric: PostingMetricValues;
}): BreakdownSingleDataSet => {
  const breakdownData: BreakdownSingleDataSet['data'] = [];

  data?.forEach((entity) => {
    const primaryDim = entity?.metadata?.shortName ?? '';
    if (!primaryDim) return;

    const breakdown: SingleDataPoint[] =
      entity?.category?.map((cat) => ({
        dim: cat?.metadata?.shortName ?? '',
        value: (() => {
          switch (metric) {
            case 'posting_salary':
              return cat?.metrics?.salary ?? null;
            case 'time_to_fill':
              return cat?.metrics?.time_to_fill ?? null;
            case 'postings_active':
              return cat?.metrics?.active ?? null;
            case 'postings_new':
              return cat?.metrics?.new ?? null;
            case 'postings_removed':
              return cat?.metrics?.removed ?? null;
            default:
              return cat?.metrics?.active ?? null;
          }
        })(),
        id: cat?.metadata?.id ? String(cat?.metadata?.id) : null,
      })) ?? [];

    breakdownData.push({ dim: primaryDim, breakdown });
  });

  return { type: DataType.BREAKDOWN_SINGLE, data: breakdownData };
};
